export default __webpack_public_path__ + "static/media/icone-claro.fd626643.svg";